import crud from './helpers/crud';
import { hasRecruiterRole } from '../StaffUtils';
import _ from 'underscore';
import $ from 'jquery';
import { getError, servletGet } from './helpers';
import join from 'url-join';

export default class StaffDAO extends crud {
  constructor(urls) {
    super(urls.STAFF_URL);
    this.EVENTS_ICS_URL = urls.EVENTS_ICS_URL;
    this.MAKE_ICS_TOKEN_LINK_URL = urls.MAKE_ICS_TOKEN_LINK_URL;
    this.SEND_ICS_LINK_URL = urls.SEND_ICS_LINK_URL;
    this.ACCOUNT_INFO_URL = urls.ACCOUNT_INFO_URL;
  }

  getICSLink({ userId, accountId }) {
    if (typeof accountId !== 'number') {
      return Promise.reject(new Error('Account ID is required'));
    }

    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.MAKE_ICS_TOKEN_LINK_URL,
        contentType: 'application/json',
        method: 'POST',
        data: JSON.stringify({ userId, accountId })
      }).then((token) => resolve(`${this.EVENTS_ICS_URL}?calendarToken=${token.token}`),
        (jqXhr) => reject(getError(jqXhr, 'Failed to fetch token')));
    });
  }

  getAccountInfo(id) {
    return servletGet(join(this.ACCOUNT_INFO_URL, id))
      .then(({ results }) => results);
  }

  getRecruiters() {
    return this.get({}).then(({ results: staff }) => _.filter(staff, hasRecruiterRole));
  }

  sendICSLink({ userId, accountId }) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.SEND_ICS_LINK_URL,
        contentType: 'application/json',
        method: 'POST',
        data: JSON.stringify({ userId, accountId })
      }).then(
        () => resolve(),
        jqXhr => reject(getError(jqXhr, 'Failed to send e-mail')));
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/util/dao/StaffDAO.js